"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icebox = void 0;
const MatrixRow_1 = require("./models/MatrixRow");
const Bar_1 = require("./models/Bar");
const TickRow_1 = require("./models/TickRow");
const IntradayRow_1 = require("./models/IntradayRow");
const Quote_1 = require("./models/Quote");
const Miniquote_1 = require("./models/Miniquote");
const url_1 = require("./helpers/url");
const api = __importStar(require("./helpers/api"));
class Icebox {
    constructor(iceboxUrl, apiToken) {
        if (!iceboxUrl)
            throw new Error('ICEBOX_URL_MISSING');
        if (!apiToken)
            throw new Error('TOKEN_MISSING');
        this.token = apiToken;
        this.iceboxUrl = iceboxUrl;
    }
    /**
     * Returns a snapshot of the miniquote (today's close, price precision, and previous close)
     * for the specified symbol.  This is useful when displaying a ticker, or another form
     * of simple quote where only the price and net change are required.
     *
     * @param {string} symbol
     * @return {*}  {Promise<Miniquote>}
     * @memberof Icebox
     */
    async symbolMiniquoteSnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `miniquote/${symbol}`), this.token);
        return new Miniquote_1.Miniquote(result);
    }
    /**
     * Returns a snapshot of the quote for the specified symbol.
     *
     * @param {string} symbol
     * @return {*}  {Promise<Quote>}
     * @memberof Icebox
     */
    async symbolQuoteSnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `quote/${symbol}`), this.token);
        return new Quote_1.Quote(result);
    }
    /**
     * Returns a snapshot of the matrix for the specified symbol.
     *
     * @param {string} symbol
     * @return {*}  {Promise<MatrixRow[]>}
     * @memberof Icebox
     */
    async symbolMatrixSnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `matrix/${symbol}`), this.token);
        return result.map((row) => new MatrixRow_1.MatrixRow(row));
    }
    /**
     * Returns a snapshot of the bar for the specified symbol.
     *
     * @param {string} symbol
     * @return {*}  {Promise<Bar>}
     * @memberof Icebox
     */
    async symbolBarSnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `bar/${symbol}`), this.token);
        return new Bar_1.Bar(result);
    }
    /**
     * Returns a snapshot of the tick for the specified symbol.
     *
     * @param {string} symbol
     * @return {*}  {Promise<TickRow[]>}
     * @memberof Icebox
     */
    async symbolTickSnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `tick/${symbol}`), this.token);
        return result.map((row) => new TickRow_1.TickRow(row));
    }
    /**
     * Returns a snapshot of the intraday for the specified symbol.
     *
     * @param {string} symbol
     * @return {*}  {Promise<IntradayRow[]>}
     * @memberof Icebox
     */
    async symbolIntradaySnapshot(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, `intraday/${symbol}`), this.token);
        return result.map((row) => new IntradayRow_1.IntradayRow(row));
    }
    /**
     * Returns a collection of snapshots for the channels
     *
     * This will transparently split the request up into separate
     * requests of max 50 channels, and recombine the result
     * so the caller is unaware of the 50 symbol limitation
     *
     * @param {IChannelList} channels
     * @return {*}  {Promise<any>}
     * @memberof Icebox
     */
    async combinedSnapshot(channels) {
        const streamUrl = (0, url_1.buildFullyQualifiedUrl)(this.iceboxUrl, 'stream');
        const channelNames = this.getChannelNames(channels);
        const fiftyChannelChunks = this.chunkArray(channelNames, 50);
        const requests = fiftyChannelChunks.map((channelsInChunk) => ({
            url: streamUrl,
            body: JSON.stringify(channelsInChunk),
            token: this.token
        }));
        return await api.postMultiple(requests);
    }
    getChannelNames(channels) {
        const channelNames = [];
        for (const channel in channels) {
            channelNames.push({ channel: channel });
        }
        return channelNames;
    }
    chunkArray(arr, size) {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    }
}
exports.Icebox = Icebox;
//# sourceMappingURL=icebox.js.map